<template>
    <div class="table-ai-wizard-overlay">
        <div class="table-ai-wizard">
            <div class="wizard-header">
                <h3 class="d-flex align-items-center gap-5">
                    <img src="/static/img/copilot.png" width="30" height="30" />
                    Supsis Asistan: Tablolar
                </h3>
                <a-icon type="close" class="close-button" @click="handleClose" />
            </div>

            <!-- Aşama 1: Prompt Girişi -->
            <div v-if="!commands.length" class="prompt-stage">
                <div class="prompt-container">
                    <h4>Supsis Asistan'a ne yapmak istediğinizi anlatın</h4>
                    <a-textarea
                        v-model="customerPrompt"
                        :rows="4"
                        placeholder="Örnek: HR süreçlerimiz için Aday takip yazılımı yapmak istiyorum..."
                    />
                    <a-button
                        type="primary"
                        :loading="copilotWaiting"
                        @click="handleAIRecommendation"
                        class="submit-button"
                    >
                        Supsis Asistan'a İlet
                    </a-button>
                </div>

                <!-- Örnek Promptlar Slider -->
                <div class="example-prompts">
                    <h4>Örnek İstekler:</h4>
                    <div class="prompt-slider-container">
                        <div class="prompt-slider" ref="slider">
                            <div class="prompt-slide" v-for="(prompt, index) in examplePrompts" :key="index">
                                <div class="prompt-card" @click="selectExamplePrompt(prompt)">
                                    <a-icon type="bulb" />
                                    <p>{{ prompt }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="slider-controls">
                            <a-button class="control-btn prev" @click="slidePrev">
                                <a-icon type="left" />
                            </a-button>
                            <a-button class="control-btn next" @click="slideNext">
                                <a-icon type="right" />
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Aşama 2: İşlem Adımları -->
            <div v-else>
                <a-progress :percent="progressPercent" stroke-color="#1890ff" show-info style="margin-bottom: 16px" />
                <!-- Adım Listesi -->
                <div class="wizard-steps">
                    <div v-for="(step, index) in steps" :key="index" class="wizard-step" :class="step.status">
                        <a-icon
                            v-if="step.status === 'waiting'"
                            type="pause-circle"
                            theme="filled"
                            style="color: #ccc; margin-right: 8px"
                        />
                        <a-icon
                            v-else-if="step.status === 'in-progress'"
                            type="loading"
                            style="color: #1890ff; margin-right: 8px"
                        />
                        <a-icon
                            v-else-if="step.status === 'success'"
                            type="check-circle"
                            theme="filled"
                            style="color: #52c41a; margin-right: 8px"
                        />
                        <a-icon
                            v-else-if="step.status === 'error'"
                            type="close-circle"
                            theme="filled"
                            style="color: #f5222d; margin-right: 8px"
                        />
                        <span>{{ step.displayLabel }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { MODULE_API } from "../../../api/module";
import { TABLE_API } from "../../../api/table";
import { mapActions, mapState } from "vuex";
import CoPilot from "../../../utils/CoPilot";
import confetti from "canvas-confetti";

export default {
    name: "TableAiWizard",
    props: {},
    data() {
        return {
            steps: [], // { displayLabel, status: 'waiting'|'in-progress'|'success'|'error', commandIndex: number }
            currentCommandIndex: 0,
            totalCommands: 0,
            tables: [],
            commands: [],
            copilotWaiting: false,
            customerPrompt: "",
            examplePrompts: [
                "HR süreçlerimiz için Aday takip yazılımı yapmak istiyorum (ATS). Bir ATS'de olması gereken herşey olsun. Türkçe isimlendirme kullan.",
                "Müşteri ilişkileri yönetimi (CRM) için gerekli olan tüm modülleri oluştur. Müşteri bilgileri, görüşme kayıtları ve fırsat yönetimi olsun.",
                "Emlak portföy yönetimi sistemi kurmak istiyorum. Gayrimenkul bilgileri, müşteri talepleri ve satış takibi yapılabilsin.",
                "Okul yönetim sistemi için öğrenci, öğretmen ve ders programı takibi yapmak istiyorum. Türkçe alanlar kullan.",
                "Proje yönetimi sistemi oluşturmak istiyorum. Görevler, ekip üyeleri, zaman takibi ve raporlama özellikleri olsun.",
                "Stok ve depo yönetimi için bir sistem kurmak istiyorum. Ürün giriş-çıkışları, stok seviyeleri ve tedarikçi takibi yapılabilsin.",
                "Servis ve bakım takip sistemi istiyorum. Müşteri cihazları, bakım geçmişi ve teknisyen atamaları yapılabilsin.",
                "Restoran yönetim sistemi kurmak istiyorum. Masa takibi, sipariş yönetimi, mutfak ekranı ve hesap işlemleri olsun.",
            ],
            currentSlide: 0,
            slideInterval: null,
        };
    },
    computed: {
        progressPercent() {
            if (this.totalCommands === 0) {
                return 0;
            }
            const completedCount = this.steps.filter(function (s) {
                return s.status === "success";
            }).length;
            return Math.round((completedCount / this.totalCommands) * 100);
        },
    },
    created() {
        // Komutları işlemek için veri hazırlığı
    },
    mounted() {
        this.startSlideShow();
    },
    beforeDestroy() {
        this.stopSlideShow();
    },
    methods: {
        ...mapActions({
            syncTables: "table/syncTables",
            syncModules: "module/syncModules",
        }),
        async handleAIRecommendation() {
            try {
                this.copilotWaiting = true;
                const copilot = CoPilot.getInstance();
                const recommendation = await copilot.createWorkspaceAppModules({
                    siteId: this.$store.state.site.site._id,
                    customerPrompt: this.customerPrompt,
                });
                if (!recommendation) {
                    this.$message.error("AI önerileri alınamadı");
                    this.copilotWaiting = false;
                    return;
                }
                this.commands = recommendation;
                this.initSteps();
                this.startProcessing();
            } catch (error) {
                console.error(error);
                this.$message.error("AI önerileri alınamadı");
            } finally {
                this.copilotWaiting = false;
            }
        },
        initSteps() {
            const localCommands = this.commands || [];
            this.totalCommands = localCommands.length;

            // Her bir komutu UI'da gösterecek bir "step" nesnesi oluşturuyoruz
            // Kullanıcıya anlamlı bir etiket vermek için
            this.steps = localCommands.map((cmd, index) => {
                const displayLabel = this.createDisplayLabel(cmd);
                return {
                    displayLabel: displayLabel,
                    status: "waiting",
                    commandIndex: index,
                };
            });
        },

        createDisplayLabel(cmd) {
            // operation'a göre kullanıcıya anlamlı bir açıklama oluştur
            let payloadName = cmd.payload && cmd.payload.name ? cmd.payload.name : "";
            if (cmd.operation === "create-table") {
                return "Tablo Oluşturulması (" + payloadName + ")";
            } else if (cmd.operation === "create-table-field") {
                // Örnek: "Adaylar tablosuna 'İsim' alanı eklenmesi"
                const tableName = this.findTableNameInCommands(cmd.payload.table);
                const fieldName = cmd.payload.name;
                return tableName + " tablosuna '" + fieldName + "' alanı eklenmesi";
            } else if (cmd.operation === "create-module") {
                payloadName = cmd.payload.displayName || "";
                return "Modül Oluşturulması (" + payloadName + ")";
            } else if (cmd.operation === "create-relation") {
                payloadName = cmd.payload.displayName || "";
                return "İlişki Oluşturulması (" + payloadName + ")";
            }
            return "Bilinmeyen İşlem";
        },

        findTableNameInCommands(tablePlaceholder) {
            // commands içinde placeholder'a karşılık gelen tablo ismini bulmaya çalışıyoruz
            // Komut array'inde "create-table" ve _id = o placeholder olan yeri bulup name'i alabiliriz
            // Bulamazsak placeholder döndürüz
            const found = (this.commands || []).find(function (c) {
                if (c.operation === "create-table") {
                    return c.payload && c.payload._id === tablePlaceholder;
                }
                return false;
            });
            if (found && found.payload && found.payload.name) {
                return found.payload.name;
            }
            // Bulunamazsa placeholder
            return tablePlaceholder;
        },

        startProcessing() {
            this.processNextCommand();
        },

        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async processNextCommand() {
            await this.sleep(Math.random() * 500 + 500);
            if (this.currentCommandIndex >= this.totalCommands) {
                this.$message.success("Uygulamanız için gerekli olan tablolar,modüller ve ilişkiler oluşturuldu");

                setTimeout(() => {
                    this.runSuccessConfetti();
                    this.$emit("close");
                }, 1000); // 1 saniye bekleyip kapatıyoruz
                return; // İşlemler tamamlandı
            }
            const step = this.steps[this.currentCommandIndex];
            step.status = "in-progress";

            const cmd = this.commands[this.currentCommandIndex];
            this.executeCommand(cmd)
                .then((createdRecord) => {
                    step.status = "success";

                    // Eğer bu komutun sonucunda bir _id döndüyse, placeholder'ı ileride kullanacak şekilde replace edelim
                    if (createdRecord && createdRecord._id) {
                        const oldPlaceholder = cmd.payload && cmd.payload._id ? cmd.payload._id : null;
                        if (oldPlaceholder && oldPlaceholder.indexOf("{{") === 0) {
                            // Diğer komutlarda bu placeholder geçiyorsa ID ile değiştir
                            this.replaceAllPlaceholdersInCommands(oldPlaceholder, createdRecord._id);
                        }
                    }

                    this.currentCommandIndex++;
                    this.processNextCommand();
                })
                .catch((err) => {
                    // Hata durumunda step'i error'a çekelim ve duralım
                    step.status = "error";
                    // Hata loglamak isterseniz
                    // console.error("Komut yürütülürken hata oluştu:", err);
                });
        },

        executeCommand(cmd) {
            if (!cmd || !cmd.operation) {
                return Promise.reject(new Error("Geçersiz komut"));
            }

            // Komut tipine göre ilgili API fonksiyonunu çağır
            if (cmd.operation === "create-table") {
                return this.handleCreateTable(cmd.payload);
            } else if (cmd.operation === "create-table-field") {
                return this.handleCreateTableField(cmd.payload);
            } else if (cmd.operation === "create-module" || cmd.operation === "create-relation") {
                // create-module ve create-relation için aynı fonksiyon (createModule) çağrılıyor
                return this.handleCreateModule(cmd.payload);
            }

            return Promise.reject(new Error("Desteklenmeyen operasyon: " + cmd.operation));
        },

        handleCreateTable(payload) {
            // "name", "description" ve opsiyonel "template" parametreleri varsa gönderiyoruz
            const pName = payload.name || "Yeni Tablo";
            const pDescription = payload.description || "";
            const pTemplate = payload.template || "";

            return TABLE_API.createTable(pName, pDescription, pTemplate).then((createdTable) => {
                // Tablo oluşturulduğunda geri dönen tablo bilgisini döndürüyoruz
                this.syncTables();
                this.$emit("table-added", createdTable);
                this.tables = [...this.tables, createdTable];
                return createdTable;
            });
        },

        handleCreateTableField(payload) {
            // "table" zorunlu, gerisi createField'e data olarak gönderilecek
            if (!payload.table) {
                return Promise.reject(new Error("Tablo ID bulunamadı"));
            }

            const tableId = payload.table;
            // Payload içinden 'table' alanını çıkarmadan, createField'e "data" olarak geçeceğiz
            // Fakat API'de createField(tableId, data) şeklinde kullanıyoruz
            // tableId haricinde diğer alanları data olarak veriyoruz
            const clonedData = _.cloneDeep(payload);
            delete clonedData.table;

            return TABLE_API.createField(tableId, clonedData).then((createdField) => {
                // Field oluşturulduğunda geri dönen field bilgisini döndürüyoruz
                this.syncTables();
                const table = this.tables.find((table) => table._id === tableId);
                table.fields = Array.isArray(table.fields) ? table.fields : [];
                table.fields.push(createdField);
                this.$emit("table-added", table);
                return createdField;
            });
        },

        handleCreateModule(payload) {
            // MODULE_API.createModule(data) şeklinde
            return MODULE_API.createModule(payload).then((createdModule) => {
                // Modül oluşturulduğunda geri dönen modül bilgisini döndürüyoruz
                this.syncModules();
                this.$emit("module-added", createdModule);
                return createdModule;
            });
        },

        replaceAllPlaceholdersInCommands(oldPlaceholder, newValue) {
            // Tüm komutların JSON string'ini alıp placeholder'ı değiştiriyoruz
            // Daha sonra parse edip this.commands'a geri yazacağız
            const commandsString = JSON.stringify(this.commands);
            // Regex ile eski placeholder geçen yerleri yeni değer ile değiştir
            // Not: global arama için /g flag'ini kullanıyoruz
            const updatedString = commandsString.replace(
                new RegExp(oldPlaceholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
                newValue
            );
            // Tekrar parse edilerek this.commands güncelleniyor
            this.commands = JSON.parse(updatedString);
        },

        handleClose() {
            // Kapatıldığında işlemlerin devam etmemesi için
            this.$emit("close");
        },
        startSlideShow() {
            this.slideInterval = setInterval(() => {
                this.slideNext();
            }, 5000); // Her 5 saniyede bir kayar
        },
        stopSlideShow() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
            }
        },
        slideNext() {
            const slider = this.$refs.slider;
            this.currentSlide = (this.currentSlide + 1) % (this.examplePrompts.length - 1);
            slider.scrollTo({
                left: this.currentSlide * (slider.offsetWidth / 2),
                behavior: "smooth",
            });
        },
        slidePrev() {
            const slider = this.$refs.slider;
            this.currentSlide = this.currentSlide === 0 ? this.examplePrompts.length - 2 : this.currentSlide - 1;
            slider.scrollTo({
                left: this.currentSlide * (slider.offsetWidth / 2),
                behavior: "smooth",
            });
        },
        selectExamplePrompt(prompt) {
            this.customerPrompt = prompt;
            // Seçilen kartı vurgulayalım ve input alanına scroll yapalım
            this.$nextTick(() => {
                const textArea = document.querySelector(".prompt-container textarea");
                if (textArea) {
                    textArea.focus();
                    textArea.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        },
        runSuccessConfetti() {
            const defaults = {
                spread: 360,
                ticks: 50,
                gravity: 0,
                decay: 0.94,
                startVelocity: 30,
                colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
            };

            const shoot = () => {
                confetti({
                    ...defaults,
                    particleCount: 40,
                    scalar: 1.2,
                    shapes: ["star"],
                });

                confetti({
                    ...defaults,
                    particleCount: 10,
                    scalar: 0.75,
                    shapes: ["circle"],
                });
            };

            shoot();
            setTimeout(shoot, 200);
            setTimeout(shoot, 300);
            setTimeout(shoot, 400);
        },
    },
};
</script>

<style lang="scss" scoped>
.table-ai-wizard-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .table-ai-wizard {
        background: #fff;
        width: 80%;
        height: 80%;
        border-radius: 8px;
        padding: 24px;
        position: relative;
        overflow: auto;
    }
}

.prompt-stage {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    gap: 40px;

    .prompt-container {
        width: 100%;
        max-width: 600px;
        text-align: center;

        h4 {
            margin-bottom: 16px;
        }

        .submit-button {
            margin-top: 16px;
        }
    }
}

.example-prompts {
    width: 100%;
    max-width: 800px;

    h4 {
        text-align: center;
        margin-bottom: 16px;
    }

    .prompt-slider-container {
        position: relative;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        padding: 0 40px;

        .prompt-slider {
            display: flex;
            overflow-x: hidden;
            scroll-snap-type: x mandatory;
            gap: 24px;
            padding: 16px 0;
            scroll-behavior: smooth;

            .prompt-slide {
                flex: 0 0 calc(50% - 12px);
                scroll-snap-align: start;
            }
        }

        .slider-controls {
            position: absolute;
            width: calc(100% + 80px);
            top: 50%;
            left: -40px;
            transform: translateY(-50%);
            display: flex;
            justify-content: space-between;
            pointer-events: none;

            .control-btn {
                pointer-events: auto;
                background: white;
                border: 1px solid #e8e8e8;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s ease;
                border-radius: 50%;
                z-index: 2;

                .anticon {
                    font-size: 18px;
                }

                &:hover {
                    background: #1890ff;
                    border-color: #1890ff;
                    color: white;
                }
            }
        }
    }
}

.prompt-card {
    background: #f0f7ff;
    border: 1px solid #d9e8ff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    cursor: pointer;

    .anticon {
        font-size: 32px;
        color: #1890ff;
        margin-bottom: 16px;
    }

    p {
        margin: 0;
        color: #454545;
        font-size: 14px;
        line-height: 1.6;
    }

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
        background: #e6f1ff;
        cursor: pointer;
    }

    &:active {
        transform: scale(0.98);
    }
}

.table-ai-wizard {
    border: 1px solid #f0f0f0;
    background-color: #fff;
    padding: 16px;
    width: 400px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 99;
    height: 500px;
    overflow: hidden;

    .wizard-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
            margin: 0;
        }

        .close-button {
            cursor: pointer;
            font-size: 16px;

            &:hover {
                color: #f5222d;
            }
        }
    }

    .wizard-steps {
        overflow-y: scroll;
        height: -webkit-fill-available;

        .wizard-step {
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            &.in-progress {
                color: #1890ff;
            }

            &.success {
                color: #52c41a;
            }

            &.error {
                color: #f5222d;
            }

            &.waiting {
                color: #ccc;
            }
        }
    }
}
</style>
